import React from 'react';
import { Radio, RadioProps } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from 'spw-theme';

const useStyles = makeStyles({
  root: {
    color: colors.mainBlue,

    '&.Mui-checked': {
      color: colors.mainBlue,
    },
  },
});

type Props = RadioProps;

const BaseRadio = ({ className, ...props }: Props) => {
  const classes = useStyles();

  return <Radio {...props} className={`${className ?? ''} ${classes.root}`} />;
};

export default BaseRadio;
